<template>
  <v-dialog v-model="openModal" max-width="560px">
    <v-card class="backup-dialog">
      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header__left">
          <div class="modal-header__icon-wrap">
            <v-icon class="modal-header__icon">backup</v-icon>
          </div>
          <div>
            <div class="modal-header__title">Backup Databases</div>
            <div class="modal-header__sub">Stream backup progress below</div>
          </div>
        </div>
        <v-btn icon flat class="modal-close-btn" @click="openModal = false">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-divider class="modal-divider"></v-divider>

      <!-- Log output -->
      <div class="backup-log-wrap">
        <div v-if="response.length" class="backup-log">
          <div
            v-for="(res, idx) in response"
            :key="idx"
            class="backup-log__line"
          >
            <v-icon x-small class="backup-log__icon">fiber_manual_record</v-icon>
            <span class="backup-log__text">{{ res }}</span>
          </div>
        </div>
        <div v-else class="backup-empty">
          <v-icon class="backup-empty__icon">cloud_upload</v-icon>
          <p class="backup-empty__text">Click <strong>Start Backup</strong> to begin streaming results</p>
        </div>
      </div>

      <v-divider class="modal-divider"></v-divider>

      <!-- Footer -->
      <div class="modal-footer">
        <v-btn flat class="modal-cancel-btn" @click="openModal = false">
          Cancel
        </v-btn>
        <v-btn depressed color="primary" class="modal-action-btn" @click="startBackup">
          <v-icon left small>play_arrow</v-icon>
          Start Backup
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from "@/mixins/APIServer";
export default {
  mixins: [API],
  data() {
    return {
      openModal: false,
      response: [],
      errors: []
    };
  },
  methods: {
    showDialog: function() {
      this.response = [];
      this.errors = [];
      this.openModal = true;
    },
    startBackup: async function() {
      this.streamBackupServers(
        res => {
          try {
            this.response.push(res);
          } catch (error) {
            this.response.push({ message: error.message });
          }
        },
        error => {
          this.errors.push({ message: error.message });
        }
      );
    }
  }
};
</script>

<style scoped lang="css">
.backup-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
}

.modal-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.modal-header__icon-wrap {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #37474F, #263238);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-header__icon {
  color: #ffffff !important;
  font-size: 20px !important;
}

.modal-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.2px;
}

.modal-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

.modal-close-btn {
  color: #94a3b8 !important;
}

.modal-divider {
  border-color: #f1f5f9 !important;
}

.backup-log-wrap {
  min-height: 200px;
  max-height: 340px;
  overflow-y: auto;
  padding: 16px 20px;
  background: #f8fafc;
}

.backup-log {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.backup-log__line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.backup-log__icon {
  color: #43a047 !important;
  flex-shrink: 0;
  margin-top: 2px;
}

.backup-log__text {
  font-family: 'SF Mono', 'Roboto Mono', monospace;
  font-size: 12px;
  color: #334155;
  line-height: 1.5;
  word-break: break-all;
}

.backup-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;
}

.backup-empty__icon {
  font-size: 40px !important;
  color: #cbd5e1 !important;
}

.backup-empty__text {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  color: #94a3b8;
  text-align: center;
  margin: 0;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 20px;
}

.modal-cancel-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 500 !important;
  text-transform: none !important;
  color: #64748b !important;
  border-radius: 10px !important;
}

.modal-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 10px !important;
  height: 40px !important;
  padding: 0 20px !important;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.3) !important;
}
</style>
